export default __webpack_public_path__ + "static/media/face-scan.5f648d19.png";